<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.infoCompta')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.journalAchat')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.journalAchat}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.journalVente')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.journalVente}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.journalOd')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.journalOd}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.compteCentralisationFournisseur')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.compteCentralisationFournisseur}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.compteCentralisationClient')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.compteCentralisationClient}}</span>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.compteChargeGestionCourante')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.compteChargeGestionCourante}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.compteProduitGestionCourante')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.compteProduitGestionCourante}}</span>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-6">
          <label class="label">
            {{ $t('detailSociete.infoSociete.schemaComptableFacturation') }}
          </label>
          <schema-comptable :objetAvecSchemaComptable="societe"
                            :isConsultation="true"
                            propertyForId="schemaComptableIdAcompteFacturation"
                            propertyForObject="schemaComptableFacturation">
          </schema-comptable>
        </div>
        <div class="column is-6">
          <label class="label">
            {{ $t('detailSociete.infoSociete.schemaComptableExtourne') }}
          </label>
          <schema-comptable :objetAvecSchemaComptable="societe"
                            :isConsultation="true"
                            propertyForId="schemaComptableIdAcompteExtourne"
                            propertyForObject="schemaComptableExtourne">
          </schema-comptable>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.nomFichierExportLot')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.nomFichierExportLot}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.tokenExtCompta')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.tokenExtCompta}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.exportOdComptabiliteDefaut')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.exportOdComptabiliteDefaut ? $t('general.oui') : $t('general.non') }}
            </span>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.destinataireComptable')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ $t(getLibelleChoixDestinataireComptable)}}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.infoSociete.refSocInter')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.refSocInter}}</span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.masqueBloc.nomComptable')"
                  custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ societe.nomComptable }}
              </span>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <b-field :label="$t('detailSociete.masqueBloc.masqueCompteComptableClient')"
                 class="column is-4"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCompteComptableClient }}
            </span>
        </b-field>
        <b-field :label="$t('detailSociete.masqueBloc.masqueCompteComptableBailleur')"
                 class="column is-4"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCompteComptableBailleur }}
            </span>
        </b-field>
        <b-field :label="$t('detailSociete.infoSociete.tvaSurDebit')"
                  custom-class="has-text-weight-normal is-italic is-marginless"
                  class="column is-4">
          <span class="has-text-weight-bold">
            {{ societe.tvaSurDebit ? $t('general.oui') : $t('general.non') }}
          </span>
        </b-field>
        <b-field :label="$t('detailSociete.infoSociete.exportComptaSpe')"
                  custom-class="has-text-weight-normal is-italic is-marginless"
                  class="column is-4">
          <span class="has-text-weight-bold">
            {{ societe.exportComptaSpe ? $t('general.oui') : $t('general.non') }}
          </span>
        </b-field>
        <b-field :label="$t('detailSociete.infoSociete.nomFichierExportSpe')"
                  custom-class="has-text-weight-normal is-italic is-marginless"
                  class="column is-4"
                  v-if="societe.exportComptaSpe">
          <span class="has-text-weight-bold">
            {{ societe.nomFichierExportSpe }}
          </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_DESTINATAIRE_COMPTABLE } from '@/configuration/societe/societe';
import schemaComptable from '@/components/general/schemaComptable';

export default {
  props: {
    societe: Object,
  },
  components: {
    schemaComptable,
  },
  computed: {
    getLibelleChoixDestinataireComptable() {
      const destinaireFind = LISTE_DESTINATAIRE_COMPTABLE.find((destinataire) => {
        return destinataire.code === this.societe.choixDestinataireComptable;
      });
      return destinaireFind ? destinaireFind.libelle : null;
    },
  },
};
</script>
